import { Component, OnInit } from '@angular/core';
import { ConnectProviderService } from '../core/connect-provider.service';
import { TreeItem } from './models/tree-item';
import { IExternalSystem } from '../core/IExternalSystem';

@Component({
  selector: 'connect-provider',
  templateUrl: 'connect-provider.component.html',
  styleUrls: ['connect-provider.component.scss']
})
export class ConnectProviderComponent implements OnInit {

  public externalSystems: IExternalSystem[];
  public selectedExternalSystem: IExternalSystem;
  public currentItemSelected: TreeItem;
  public guidProvider: string;

  constructor(private _connectProviderService: ConnectProviderService) {
  }

  ngOnInit() {
    this._connectProviderService.getExternalSystems().subscribe((data) => {
      this.externalSystems = data;
    });
  }

  selectExternalSystem(externalSystem: IExternalSystem) {
    this.selectedExternalSystem = externalSystem;
    this.currentItemSelected = null;
  }

  selectItem(item: TreeItem) {
    this.currentItemSelected = item;
    if (item.type === 'Provider')
      this.guidProvider = item.id;
    if (item.type === 'VirtualEntities') {
      this.findGuidProvider(item);
    }
  }

  findGuidProvider (item: TreeItem) {
    this.selectedExternalSystem.nodes.forEach(provider => {
      const guidVirtualEntities = provider.nodes.find(nodes => nodes.type === 'VirtualEntities');
      if (guidVirtualEntities && guidVirtualEntities.id === item.id)
        this.guidProvider = provider.id;
    });
  }
}
